export const DEBUG = false;


// Base speed for all animations
export const ANIMATION_SPEED = 1;

// Wheel rotation speed
export const WHEEL_SPEED_MULTIPLIER = 1;

// Ground movement speed
export const GROUND_SPEED_MULTIPLIER = 0.35;

// Obstacle movement speed (5.714285714 is the multiplier to get from 0.35 to 2)
export const OBSTACLE_SPEED_MULTIPLIER = GROUND_SPEED_MULTIPLIER * (5.714285714);

// Engine smoke constants (for 3D model)
export const ENGINE_SMOKE_CONSTANTS = {
    // Initial transform
    INITIAL_POSITION: [-0.6, 0.4, -2.8],
    INITIAL_ROTATION: [-1.6, 0, 0],

    // Particle system
    PARTICLE_COUNT: 9,
    MAX_LIFETIME: 3.0,
    EMIT_DELAY_RANGE: 0.05,
    INITIAL_ENGINE_DELAY: 1.5, // Delay in seconds before smoke starts after engine start
    
    // Velocity parameters
    VELOCITY: {
        HORIZONTAL_SPREAD: 0.002,
        UPWARD_MIN: 0.01,
        UPWARD_MAX: 0.03,
        DEPTH_SPREAD: 0.002
    },

    // Turbulence
    TURBULENCE: 0.0002,

    // Visual parameters
    VISUAL: {
        MAX_OPACITY: 0.4,
        MAX_SIZE: 4,
        SIZE_MULTIPLIER: 6,
        COLOR: [0.3, 0.3, 0.3]
    }
};

// Exhaust pipe vibration settings
export const EXHAUST_VIBRATION = {
    AMPLITUDE: 0.0025, // 0.02 radians ≈ 1.15 degrees
    POSITION_AMPLITUDE: 0.001, // Small position changes
    FREQUENCIES: {
        ROTATION_X: 50, // 50 Hz
        ROTATION_Z: 45, // 45 Hz
        POSITION_X: 40, // 40 Hz
        POSITION_Y: 45, // 45 Hz
        POSITION_Z: 50  // 50 Hz
    }
};

// Loading screen smoke effect constants
export const LOADING_SCREEN_DELAY = 10000;  // 3 seconds delay before fade out starts after animation completes
export const SMOKE_FADE_DURATION = 5000;      // 3 seconds for fade out animation
export const SMOKE_FADE_START_DELAY = 2000;   // 2 seconds before fade animation starts
export const SMOKE_APPEAR_DELAY = 300;       // 1 second before smoke appears
export const SMOKE_OPACITY = 0.5;             // Initial opacity
export const SMOKE_DENSITY = 20;              // Number of particles
export const SMOKE_LIGHT_INTENSITY = 0.9;     // Light brightness
export const SMOKE_FINAL_OPACITY = 0;         // Final opacity value when fading out
export const SMOKE_COLOR = [1, 0, 5];         // Red color (RGB)
// export const SMOKE_COLOR = [1, 0, 3];         // Red color (RGB)

// SVG animation constants
export const SVG_ANIMATION_DELAY = 300;      // 3 seconds delay before SVG animation starts
export const SVG_FADE_OUT_DELAY = 5000;       // 2 seconds additional delay before fade out starts after animation completes

// Utility function to convert HEX to RGB array [0-1]
const hexToRGB = (hex) => {
    // Remove the hash if present
    hex = hex.replace(/^#/, '');
    
    // Parse the hex values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    // Convert to 0-1 range
    return [r/255, g/255, b/255];
};

export const INTRO_COLORS = {
    FIRST: {
        BACKGROUND: '#000000', //fix
        SMOKE: hexToRGB('#6214ff'),
        TEXT: '#FFFFFF',
        CIRCLE_COLOR: '#6214ff',
        CIRCLE_STROKE: '#FFFFFF',
        CIRCLE_SIZE: 10
    },
    SECOND: {
        BACKGROUND: '#E0E0E0',
        SMOKE: null, 
        TEXT: '#000000',
        CIRCLE_COLOR: '#606060',
        CIRCLE_STROKE: '#000000',
        CIRCLE_SIZE: 10
    },
    THIRD: {
        BACKGROUND: '#000000',
        SMOKE: hexToRGB('#FF0000'), 
        TEXT: '#FFFFFF',
        CIRCLE_COLOR: '#FF0000',
        CIRCLE_STROKE: '#000000',
        CIRCLE_SIZE: 10
    },
    FIFTH: {
        BACKGROUND: '#000000',
        SMOKE: hexToRGB('#00ff80'), 
        TEXT: '#ff007f',
        CIRCLE_COLOR: '#00ff80',
        CIRCLE_STROKE: '#0088FF',
        CIRCLE_SIZE: 10
    },
    FOURTH: {
        BACKGROUND: '#1924B1',
        SMOKE: hexToRGB('#580EAD'), 
        TEXT: '#FFCF00',
        CIRCLE_COLOR: '#FFCF00',
        CIRCLE_STROKE: '#0088FF',
        CIRCLE_SIZE: 10
    },
}

// WebSocket Configuration
export const WS_CONFIG = {
    URL: 'wss://ws.chrb.pro:8080/ws'  // Using secure WebSocket with domain
};

// WebSocket Status Codes
export const WS_STATUS = {
    NORMAL_CLOSURE: 1000,        // Normal closure; the connection successfully completed whatever purpose for which it was created
    GOING_AWAY: 1001,           // The endpoint is going away (server shutdown/browser tab closing)
    PROTOCOL_ERROR: 1002,       // Protocol error
    UNSUPPORTED_DATA: 1003,     // Received data of a type it cannot accept
    POLICY_VIOLATION: 1008,     // Policy violation (authentication failure, rate limit, etc.)
    MESSAGE_TOO_BIG: 1009,      // Message is too big to process
    INTERNAL_ERROR: 1011,       // Server encountered an unexpected condition
    SERVICE_RESTART: 1012,      // Server is restarting
    TRY_AGAIN_LATER: 1013,      // Server is temporarily unable to handle the connection
    BAD_GATEWAY: 1014          // Server acting as gateway received an invalid response
};


export const CAMERA_ANIMATION = {
  // Начальные позиции
  INITIAL: {
    POSITION: [3, 0.6, 5],
    TARGET: [0, 0, 0], // Позиция машины
  },
  
  // Параметры кругового движения
  CIRCULAR: {
    RADIUS: 8,
    START_HEIGHT: 1.5,
    END_HEIGHT: 3,
  },
  
  // Позиция куба
  CUBE: {
    POSITION: [5, 2, 8],
  },
  
  // Параметры анимации
  ANIMATION: {
    DURATION: 0.1,
  },

  CURVE_POINTS: [
    [2.5, 0.6, 5],        // Начальная точка
    [3, 0.6, -4],       // Начальная точка
    [0, 0.5, -6],          // Смотрим на машину
    [0, 0.5, -5],          // Смотрим на машину
    [-6, 3, 0],          // Смотрим на машину
    [0, 20, 5],          // Смотрим на машину
    [7, 20, 5],          // Смотрим на машину

  ],

  LOOK_AT_POINTS: [
    [0, 0.5, 1],          // Смотрим на машину
    [0, 0.5, -2.5],          // Смотрим на машину
    [0, 0.5, -2.5],          // Смотрим на машину
    [0, 0.5, -2.5],          // Смотрим на машину
    [8, -1, 0],          // Смотрим на машину
    [0, 0, 0],          // Смотрим на машину
    [7, 0, 0],          // Смотрим на машину

  ]
};